import { BookingStatus, BookingStatusMap } from "utils/interfaces"

export const isCancelled = (status: BookingStatus) =>
    [
        BookingStatusMap.CANCELLED,
        BookingStatusMap.CANCELLED_AFTER_PAYMENT,
        BookingStatusMap.CANCELLED_WITHOUT_REFUND,
    ].find((item) => item === status)

export const isPaidAndNotPaid = (status: BookingStatus) =>
    [
        BookingStatusMap.NOT_PAID,
        BookingStatusMap.PAID,
        BookingStatusMap.PAID_AFTER_CANCELLATION,
    ].find((item) => item === status)
